/** Fixed trial length (1V-5895); the specialist never picks a length. */
export const TRIAL_MEMBERSHIP_LENGTH_DAYS = 30;
